import { render } from "./BoardLeft.vue?vue&type=template&id=23a13f4e&scoped=true"
import script from "./BoardLeft.vue?vue&type=script&lang=js"
export * from "./BoardLeft.vue?vue&type=script&lang=js"

import "./BoardLeft.vue?vue&type=style&index=0&id=23a13f4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a13f4e"]])

export default __exports__